// Lib
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useFormikContext } from 'formik'

// Include in project
import styles from './index.module.scss'
import { Button } from 'component'
import { setOpenDialogWithInput, setCloseDialog, setOpenDialog } from 'states/slice/modalDialog'
import { ETransformationDataToServer, transformationDataToServer } from 'utils/tranformData'

interface Props {
  approvePointCampaign: any
}

const FooterButtonApprovePoints: React.FC<Props> = (props: Props) => {
  const { values } = useFormikContext<any>()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const onApprove = () => {
    const packData = transformationDataToServer({
      values: values.campaignDetail[0],
      type: ETransformationDataToServer.ApprovePointCampaign,
    })

    props.approvePointCampaign({ variables: packData }).then((res: any) => {
      if (res.data.approvePointCampaign.res_code === '99') return

      dispatch(setCloseDialog())
      navigate('/approve-point/campaign-list')
    })
  }

  const onReject = (comment: string | undefined) => {
    const packData = transformationDataToServer({
      values: { ...values.campaignDetail[0], remark: comment },
      type: ETransformationDataToServer.RejectPointCampaign,
    })

    props.approvePointCampaign({ variables: packData }).then((res: any) => {
      if (res.data.approvePointCampaign.res_code === '99') return

      dispatch(setCloseDialog())
      navigate('/approve-point/campaign-list')
    })
  }

  return (
    <section className={styles.container}>
      <Button
        typeButton="button"
        type="outline"
        fullWidth
        name={t<string>('approvePoint.reject')}
        disabled={false}
        functionOnClick={() =>
          dispatch(
            setOpenDialogWithInput({
              title: t<string>('ReviewCampaign.rejectConfirm'),
              description: `Are you sure to reject the point in the ${values.campaignDetail[0].campaignName}`,
              status: 'danger',
              titleInput: 'Comment and Detail',
              functionOnSubmit: (comment) => {
                onReject(comment)
              },
            }),
          )
        }
      />
      <Button
        typeButton="button"
        type="primary"
        fullWidth
        name={t<string>('approvePoint.approve')}
        disabled={false}
        functionOnClick={() =>
          dispatch(
            setOpenDialog({
              title: t<string>('ReviewCampaign.approveConfirm'),
              description: `Are you sure to approve the point in the ${values.campaignDetail[0].campaignName}`,
              status: 'success',
              functionOnSubmit: () => {
                onApprove()
              },
            }),
          )
        }
      />
    </section>
  )
}

export default FooterButtonApprovePoints
